import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import VueSVGIcon from 'vue-svgicon'


import vueCustomElement from 'vue-custom-element'

Vue.use(VueSVGIcon)
Vue.use(vueCustomElement)

Vue.config.productionTip = false

Vue.prototype.$screen = Vue.observable({
  width: window.innerWidth,
  height: window.innerHeight
});

window.addEventListener('resize', () => {
  Vue.prototype.$screen.width = window.innerWidth;
  Vue.prototype.$screen.height = window.innerHeight;
});

Vue.customElement('taka-widget', App, {
  beforeCreateVueInstance(RootComponentDefinition) {
    RootComponentDefinition.i18n = i18n;
    return RootComponentDefinition;
  },
});